import React from 'react';
import {
    Col, Row, Table, Modal, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import Select from 'react-select';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../elements/CustomButton/CustomButton.jsx';
import Checkbox from '../../elements/CustomCheckbox/CustomCheckbox.jsx';
import ContactService from "../../services/ContactService";
import VerEvento from './ModalVerEvento.jsx';
import { API_ROOT } from '../../variables/api-config';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalEvento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadCollapsed: true,
      archivos: this.props.evento ? this.props.evento.archivos : [],
      ownedCalendars: null,
      asistentes: this.props.evento ? this.props.evento.asistentes : [],
      nombre: this.props.evento ? this.props.evento.nombre : '',
      descripcion: this.props.evento ? this.props.evento.descripcion : '',
      fechainicio: this.props.evento ? this.props.evento.fechainicio : this.props.daysAndTimes.fechainicio,
      horainicio: this.props.evento ? this.props.evento.horainicio : this.props.daysAndTimes.horainicio,
      fechafin: this.props.evento ? this.props.evento.fechafin : this.props.daysAndTimes.fechafin,
      horafin: this.props.evento ? this.props.evento.horafin : this.props.daysAndTimes.horafin,
      calendarioSelect: this.props.evento ? {value: this.props.evento.calendarioid, label: this.props.evento.calendarionombre} : '',
      tipoSelect: this.props.evento ? {value: this.props.evento.tipo, label: this.props.evento.tipo} : '',
      lugar: this.props.evento ? this.props.evento.lugar : '',
      confirmado: this.props.evento ? parseInt(this.props.evento.confirmado, 10) : false,
      todoeldia: this.props.evento ? parseInt(this.props.evento.todoeldia, 10): false,
      id: this.props.evento ? this.props.evento.id : null,
      error: {},
      errorArchivo: {},
      step: 1,
      nombreArchivo: '',
      descripcionArchivo: '',
      file: null,
      contactsOptions: null,

    };
    this.contactService = new ContactService();
    this.generateOptions = this.generateOptions.bind(this);
    this.onChangeTodoElDia = this.onChangeTodoElDia.bind(this);
    this.saveEvent = this.saveEvent.bind(this);
    this.clearError = this.clearError.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
    this.addContact = this.addContact.bind(this);
    this.generateAsistentesList = this.generateAsistentesList.bind(this);
    this.deleteContact = this.deleteContact.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.saveEventFile = this.saveEventFile.bind(this);
    this.generateFileList = this.generateFileList.bind(this);
    this.clearErrorArchivo = this.clearErrorArchivo.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
    this.showWarningDelete = this.showWarningDelete.bind(this);
  }

  componentWillMount() {
    this.contactService.getContacts()
      .then(res => {
        const contactsOptions = res.contacts.map((item) => {
          return {value: item.id, label: `${item.apellido} ${item.nombre}`, nombre: item.nombre, apellido: item.apellido}
        });
        this.setState({contactsOptions});
      })
      .catch(err =>
        this.props.errorAlert(
          <div>
            Ocurrio un error al cargar los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>)
      );
    this.props.calendarServices.getOwnCalendars()
      .then(res => {
        this.setState({ownedCalendars: res.calendarios});
      })
      .catch(err =>
        this.props.errorAlert(
          <div>
            Ocurrio un error al cargar los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>)
      );
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ file: this.uploadInput.files[0]});
    this.clearErrorArchivo('file');
  }

  onChangeTodoElDia(value) {
    this.setState({todoeldia: value});
    if (value) {
      this.setState({horainicio: null, horafin: null});
    }
    this.clearError('horainicio');
    this.clearError('horafin');
  }

  generateOptions() {
    const options = this.state.ownedCalendars.map((item) => {
      return {value: item.id, label: item.nombre};
    });
    return options;
  }

  clearError(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({error: auxError});
  }

  clearErrorArchivo(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({errorArchivo: auxError});
  }

  checkErrors(event) {
    const auxError = this.state.error;
    let error = false;
    Object.keys(event).forEach((key) => {
      if (!event[key] || event[key] === '') {
        if (key !== 'confirmado' && key !== 'todoeldia' && key !== 'id') {
          if (!(this.state.todoeldia && (key === 'horainicio' || key === 'horafin'))) {
            auxError[key] = true;
            error = true;
          }
        }
      }
    });
    this.setState({error: auxError});
    return error;
  }

  checkErrorsArchivo(event) {
    const auxError = this.state.errorArchivo;
    let error = false;
    Object.keys(event).forEach((key) => {
      if (!event[key] || event[key] === '') {
        auxError[key] = true;
        error = true;
      }
    });
    this.setState({errorArchivo: auxError});
    return error;
  }

  saveEvent() {
    const calendarioid = this.state.calendarioSelect ? this.state.calendarioSelect.value : null;
    const tipo = this.state.tipoSelect ? this.state.tipoSelect.label : null;
    const event = {
      calendarioid,
      nombre: this.state.nombre,
      descripcion: this.state.descripcion,
      fechainicio: this.state.fechainicio,
      fechafin: this.state.fechafin,
      horainicio: this.state.todoeldia ? '00:00' : this.state.horainicio,
      horafin: this.state.todoeldia ? '23:59' : this.state.horafin,
      lugar: this.state.lugar,
      tipo,
      confirmado: this.state.confirmado ? 1 : 0,
      todoeldia: this.state.todoeldia ? 1 : 0,
      id: this.state.id,
    };

    const error = this.checkErrors(event);

    if (!error) {
      this.props.calendarServices.postEvent(event)
        .then(res => {
          this.setState({step: 2, id: res});
        })
        .catch(err => {
          this.props.errorAlert(
            <div>
              Ocurrio un error al guardar los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>)
        });
    } else {
      this.props.errorAlert(
        <div>
          Uno o mas campos requeridos no han sido completados!
        </div>);
    }
  }

  showWarningDelete() {
    this.setState({
      alert: (
        <SweetAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title="Eliminar Evento"
          onConfirm={() => this.deleteEvent()}
          onCancel={() => this.setState({alert: null})}
          confirmBtnBsStyle="danger"
          confirmBtnText="Si!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Desea eliminar el evento actual?`}
        </SweetAlert>
      )
    });
  }

  deleteEvent() {
    this.props.calendarServices.deleteEvent(this.state.id)
    .then(res => {
      this.setState({alert: null});
      this.props.closeModal();
    })
    .catch(err => {
      this.setState({alert: null});
      this.props.errorAlert(
        <div>
          Ocurrio un error al guardar los datos, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>)
    });
  }

  saveEventAssistans() {
    const asistentesToSend = {eventoid: this.state.id, assistants: this.state.asistentes};
    if (this.state.asistentes.length === 0) {
      this.setState({step: 3});
    } else {
      this.props.calendarServices.postEventAssistant(asistentesToSend)
        .then(res => {
          this.setState({step: 3});
        })
        .catch(err => {
          this.props.errorAlert(
            <div>
              Ocurrio un error al guardar los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>)
        });
    }
  }

  addContact(item) {
    const auxAsistentes = [...this.state.asistentes];
    auxAsistentes.push({id: item.value, nombre: item.nombre, apellido: item.apellido});
    this.setState({asistentes: auxAsistentes});
  }

  deleteContact(index) {
    const auxAsistentes = [...this.state.asistentes];
    auxAsistentes.splice(index, 1);
    this.setState({ asistentes: auxAsistentes });
  }

  generateAsistentesList() {
    return this.state.asistentes.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.id}</td>
          <td>{`${item.apellido} ${item.nombre}`}</td>
          <td>
            <Button simple bsStyle="danger" bsSize="xs" onClick={() => this.deleteContact(index)}>
                <i className="fa fa-times"></i>
            </Button>
          </td>
        </tr>
      )
    });
  }

  saveEventFile() {
    const archivo = {
      eventoid: this.state.id,
      nombre: this.state.nombreArchivo,
      description: this.state.descripcionArchivo,
      file: this.state.file,
    };
    const error = this.checkErrorsArchivo(archivo);

    if (!error) {
      this.props.calendarServices.postEventFile(archivo)
      .then(res => {
        const auxArchivos = [...this.state.archivos];
        console.log(res);
        auxArchivos.push({nombre: archivo.nombre, descripcion: archivo.description});
        this.setState({
          archivos: auxArchivos,
          nombreArchivo: '',
          descripcionArchivo: '',
          file: null,
          uploadCollapsed: true,
        });
      })
      .catch(err => {
        this.props.errorAlert(
          <div>
            Ocurrio un error al subir el archivo, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>)
        });
    } else {
      this.props.errorAlert(
        <div>
          Complete todos los campos requeridos!
        </div>
      );
    }
  }

  generateFileList() {
    return this.state.archivos.map((item, index) => {
      return (
        <tr key={index}>
          <td style={{textAlign: 'left'}}>{item.nombre}</td>
          <td>{item.descripcion}</td>
          <td style={{textAlign: 'right'}}>
            <Button simple bsStyle="info" bsSize="xs" disabled={!item.id}>
              {item.id ?
                <a href={`${API_ROOT}/calendar/event/download/file?id=${item.id}`}>
                  <i className="fa fa-download"></i>
                </a> :
                <i className="fa fa-download"></i>
              }
            </Button>
          </td>
        </tr>
      );
    });
  }

  render() {
    const tipoList = [
      {value: 1, label: 'Reunión'},
      {value: 2, label: 'Concursos y Premios'},
      {value: 3, label: 'Capacitación'},
      {value: 4, label: 'Otros'},
    ];
    let modalTitle;
    if (!this.props.evento) {
      modalTitle = 'Crear Evento';
    } else if (parseInt(this.props.evento.idowner, 10) === parseInt(this.props.userId, 10)) {
      modalTitle = 'Editar Evento';
    } else {
      modalTitle = 'Información del Evento';
    }
    return (
      <div>
        {this.state.alert}
        <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }}>
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.props.evento && this.props.evento.idowner !== this.props.userId ?
                    <VerEvento evento={this.props.evento} /> :
                    <div>
                      {this.state.step === 1 &&
                        <div>
                          {!this.state.ownedCalendars ?
                            <Row>
                              <Col md={12}>
                              </Col>
                            </Row> :
                            <Row>
                              <Col md={12}>
                                <Form>
                                  <FormGroup validationState={this.state.error.calendarioid ? 'error': null}>
                                    <ControlLabel>{'Calendario'} </ControlLabel>
                                    <Select
                                      disabled={this.props.evento && true}
                                      style={{ borderColor: this.state.error.calendarioid ? "#e40040" : "#aaa"}}
                                      placeholder="Calendario"
                                      name="usersCalendar"
                                      value={this.state.calendarioSelect}
                                      options={this.generateOptions()}
                                      onChange={(item) => this.setState({calendarioSelect: item}, this.clearError('calendarioid'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={12}>
                                <Form>
                                  <FormGroup validationState={this.state.error.nombre ? 'error': null}>
                                    <ControlLabel>{'Nombre'} </ControlLabel>
                                    <FormControl
                                      type="text" value={this.state.nombre ? this.state.nombre : ''}
                                      onChange={(e) => this.setState({nombre: e.target.value}, this.clearError('nombre'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={12}>
                                <Form>
                                  <FormGroup validationState={this.state.error.descripcion ? 'error': null}>
                                    <ControlLabel>{'Descripcion'}</ControlLabel>
                                    <FormControl
                                      componentClass="textarea" type="text" style={{height: 100}}
                                      value={this.state.descripcion}
                                      onChange={(e) => this.setState({descripcion: e.target.value}, this.clearError('descripcion'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.error.fechainicio ? 'error': null}>
                                    <ControlLabel>{'Fecha Inicio'} </ControlLabel>
                                    <FormControl
                                      type="date" value={this.state.fechainicio ? this.state.fechainicio : ''}
                                      onChange={(e) => this.setState({fechainicio: e.target.value}, this.clearError('fechainicio'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.error.horainicio ? 'error': null}>
                                    <ControlLabel>{'Hora Inicio'} </ControlLabel>
                                    <FormControl
                                      disabled={this.state.todoeldia}
                                      type="time" value={this.state.horainicio ? this.state.horainicio : ''}
                                      onChange={(e) => this.setState({horainicio: e.target.value}, this.clearError('horainicio'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.error.fechafin ? 'error': null}>
                                    <ControlLabel>{'Fecha Fin'} </ControlLabel>
                                    <FormControl
                                      type="date" value={this.state.fechafin ? this.state.fechafin : ''}
                                      onChange={(e) => this.setState({fechafin: e.target.value}, this.clearError('fechafin'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.error.horafin ? 'error': null}>
                                    <ControlLabel>{'Hora Fin'} </ControlLabel>
                                    <FormControl
                                      disabled={this.state.todoeldia}
                                      type="time" value={this.state.horafin ? this.state.horafin : ''}
                                      onChange={(e) => this.setState({horafin: e.target.value}, this.clearError('horafin'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Checkbox
                                  label={'Confirmado'}
                                  number={'confirmado'}
                                  isChecked={this.state.confirmado}
                                  handleOnChange={(e) => this.setState({ confirmado: e })}
                                />
                              </Col>
                              <Col md={6}>
                                <Checkbox
                                  label={'Todo el día'}
                                  number={'todoeldia'}
                                  isChecked={this.state.todoeldia}
                                  handleOnChange={(e) => this.onChangeTodoElDia(e)}
                                />
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.error.lugar ? 'error': null}>
                                    <ControlLabel>{'Lugar'} </ControlLabel>
                                    <FormControl
                                      type="text" value={this.state.lugar ? this.state.lugar : ''}
                                      onChange={(e) => this.setState({lugar: e.target.value}, this.clearError('lugar'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.error.tipo ? 'error': null}>
                                    <ControlLabel>{'Tipo de Evento'} </ControlLabel>
                                    <Select
                                      style={{ borderColor: this.state.error.tipo ? "#e40040" : "#aaa"}}
                                      placeholder="Calendario"
                                      name="usersCalendar"
                                      value={this.state.tipoSelect}
                                      options={tipoList}
                                      onChange={(item) => this.setState({tipoSelect: item}, this.clearError('tipo'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                            </Row>
                          }
                        </div>
                      }
                      {this.state.step === 2 &&
                        <Row>
                          <Col md={12}>
                            <Form>
                              <FormGroup validationState={this.state.error.tipo ? 'error': null}>
                                <ControlLabel>{'Seleccione los invitados al evento...'} </ControlLabel>
                                <Select
                                  style={{ borderColor: this.state.error.tipo ? "#e40040" : "#aaa"}}
                                  placeholder="Seleccione participante"
                                  name="usersCalendar"
                                  value={''}
                                  options={this.state.contactsOptions}
                                  onChange={(item) => this.addContact(item)}
                                />
                              </FormGroup>
                            </Form>
                          </Col>
                          <Col md={12}>
                            {this.state.asistentes.length === 0 ?
                              <span>No hay asistentes</span> :
                              <Table responsive>
                                <thead>
                                  <tr>
                                    <th>Id</th>
                                    <th>Nombre y Apellido</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.generateAsistentesList()}
                                </tbody>
                              </Table>
                            }
                          </Col>
                        </Row>
                      }
                      {this.state.step === 3 &&
                        <Row>
                          {this.state.uploadCollapsed ?
                            <Col md={12} style={{textAlign: 'center'}}>
                              <Button onClick={() => this.setState({uploadCollapsed: false})} bsStyle="primary" fill={true}>
                                Subir Archivo
                              </Button>
                            </Col> :
                            <Col md={12}>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.errorArchivo.nombre ? 'error': null}>
                                    <ControlLabel>{'Nombre'} </ControlLabel>
                                    <FormControl
                                      type="text" value={this.state.nombreArchivo ? this.state.nombreArchivo : ''}
                                      onChange={(e) => this.setState({nombreArchivo: e.target.value}, this.clearErrorArchivo('nombre'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.errorArchivo.description ? 'error': null}>
                                    <ControlLabel>{'Descripción'} </ControlLabel>
                                    <FormControl
                                      type="text" value={this.state.descripcionArchivo ? this.state.descripcionArchivo : ''}
                                      onChange={(e) => this.setState({descripcionArchivo: e.target.value}, this.clearErrorArchivo('description'))}
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <Form>
                                  <FormGroup validationState={this.state.errorArchivo.file ? 'error': null}>
                                    <ControlLabel>{'Descripción'} </ControlLabel>
                                    <FormControl
                                      type="text" value={this.state.file ? this.state.file.name : 'No se seleccionó ningún archivo..'}
                                      disabled
                                    />
                                  </FormGroup>
                                </Form>
                              </Col>
                              <Col md={6}>
                                <span style={{ float: 'left' }}>
                                  <input ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                                </span>
                                <span style={{ float: 'right', paddingTop: 4 }}>
                                  <Button onClick={() => this.uploadInput.click()} bsStyle="primary" fill={true}>Seleccionar archivo</Button>
                                  <Button disabled={!this.state.file} onClick={() => this.setState({ file: null })} bsStyle="danger" fill={true}>
                                    <i className="fa fa-ban"></i>
                                  </Button>
                                </span>
                              </Col>
                              <Col md={12} style={{textAlign: 'center'}}>
                                <Button disabled={!this.state.file} onClick={this.saveEventFile} bsStyle="success" fill={true}>
                                  Subir <i className="fa fa-upload"></i>
                                </Button>
                              </Col>
                            </Col>
                          }
                          <Col md={12}>
                            {this.state.archivos.length === 0 ?
                              <div>No hay archivos...</div> :
                              <Table responsive>
                                <thead>
                                  <tr>
                                    <th style={{textAlign: 'left'}}>Nombre</th>
                                    <th>Descripción</th>
                                    <th style={{textAlign: 'right'}}></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.generateFileList()}
                                </tbody>
                              </Table>
                            }
                          </Col>
                        </Row>
                      }
                    </div>
                  }
                </Modal.Body>
                {(!this.props.evento || this.props.evento.idowner === this.props.userId) &&
                  <Modal.Footer>
                    {this.props.evento &&
                      <Button fill bsStyle="danger" onClick={this.showWarningDelete} style={{float: 'left'}}>
                        Borrar Evento
                      </Button>
                    }
                    <Button simple onClick={this.props.closeModal}>
                      Cancelar
                    </Button>
                    {this.state.step === 1 &&
                      <Button
                        bsStyle="success" fill onClick={() => this.saveEvent()}
                      >
                        Siguiente
                      </Button>
                    }
                    {this.state.step === 2 &&
                      <Button
                        bsStyle="success" fill onClick={() => this.saveEventAssistans()}
                      >
                        Siguiente
                      </Button>
                    }
                    {this.state.step === 3 &&
                      <Button
                        bsStyle="success" fill onClick={this.props.closeModal}
                      >
                        Finalizar
                      </Button>
                    }
                  </Modal.Footer>
                }
              </div>
            }
          />
        </Modal>
      </div>
    );
  }
}

export default ModalEvento;



// WEBPACK FOOTER //
// ./src/views/Calendar/ModalEvento.jsx